import React, { useEffect, useState } from 'react'
import { Popup } from 'antd-mobile'
import '../css/Modifyprice.css'
import { CloseOutlined } from '@ant-design/icons'
import PriceChange from '../pricechange/PriceChange'
export default function AllPrice(props) {

  const [trade, setTrade] = useState({})
  const [visible, setVisible] = useState(false)
  const [priceVisible, setPriceVisible] = useState(false)

  useEffect(() => {
    setVisible(props.visible)
  }, [props.visible])

  useEffect(() => {
    setTrade(props.trade)
  }, [props.trade])

  const changePrice = () => {
    setPriceVisible(true)
    props.handleDismiss()
  }

  return (
    <div>
      <Popup
        visible={visible}
        bodyStyle={{
          borderTopLeftRadius: '13px',
          borderTopRightRadius: '13px',
        }}
      >
        <div className='bargain-index'>
          <div className="close" onClick={() => props.handleDismiss()}>
            <CloseOutlined></CloseOutlined>
          </div>
          <div className="header">
            <div className="title">全部出价</div>
            <div className="game">
              <div className="game-info">
                <div className="gamename">游戏名称：<span className='subtitle'>{trade?.game_name}</span></div>
                <div className="gamename">区服：<span className='subtitle'>{trade?.server_name}</span></div>
                <div className="gamename">价格：￥<span className='subtitle'>{trade?.sell_price}</span></div>
              </div>
              <div className="btn" onClick={changePrice}>立即改价</div>
            </div>
          </div>
          <div className="list">
            {trade?.bargain_records?.map(item => {
              return (
                <div className="item">
                  <div className="user">
                    <div className="username">{item.nick_name}</div>
                    <div className="desc">给出的价格</div>
                    <div className="desc">有效期至{item.expired_time}</div>
                  </div>
                  <div className="price">￥{item.bargain_price}</div>
                </div>
              )
            })}
          </div>
        </div>
      </Popup>
      <PriceChange trade={trade} handleDismiss={() => setPriceVisible(false)} visible={priceVisible}></PriceChange>
    </div>
  )
}
